'use client'
import { useTranslations } from 'next-intl'

import { IconShare } from '@repo/design-system-cf/components/icons'
import { useSocialShareDialog } from '@repo/web-ui/ask-cf/contexts/social-share-dialog-context'
import { Button } from '@repo/design-system-cf/components/button'

export function ShareButton({
  detailsHref,
  withText = false,
}: {
  detailsHref: string
  withText?: boolean
}) {
  const t = useTranslations('pages.clubhouse.discussions')
  const { openDialog } = useSocialShareDialog()
  const handleClickShare = () => {
    openDialog(detailsHref, 'Share Discussion')
  }

  if (withText) {
    return (
      <div
        onClick={handleClickShare}
        className="pointer-events-auto flex flex-row items-center cursor-pointer justify-start p-2 gap-2 hover:bg-cf-grey-100 rounded relative w-full"
      >
        <IconShare className="size-5" />
        <div className="text-14 font-medium">{t('share')}</div>
      </div>
    )
  }

  return (
    <Button
      onClick={handleClickShare}
      variant="ghost"
      iconLeft={<IconShare className="size-5" />}
    />
  )
}
